'use client';

import { usePrint } from '@/lib/hooks';
import { Guide, PageProps } from '@/lib/types';
import { Breadcrumb, Empty, Section } from '@/ui';
import { Content, Employee } from '@/widgets';
import { Container } from '@mantine/core';

type Props = {
  data: PageProps & { title: string; guides: Guide[] };
};

export default function Guides({ data }: Props) {
  const { ref, handlePrint } = usePrint();

  const breadcrumbItems = [
    { title: data?.breadcrumb, href: `/general-menu/${data?.menu_id}` },
    { title: data?.title, isCurrent: true },
  ];

  return (
    <Container>
      <Section rightMenu={{ isActive: true, id: data?.menu_id, activeItem: { id: data?.menu_item_id } }}>
        <Content ref={ref}>
          <Content.Header details={{ handlePrint }}>
            <Breadcrumb items={breadcrumbItems} />
          </Content.Header>
          <Content.Title>{data?.title}</Content.Title>
          <Content.Body isShareable className="flex flex-col gap-3">
            {data?.guides?.length > 0 ? (
              data?.guides?.map((guide) => <Employee key={guide?.id} {...guide} />)
            ) : (
              <Empty />
            )}
          </Content.Body>
        </Content>
      </Section>
    </Container>
  );
}
